import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { Links } from 'src/class/links';
import { Formulario } from 'src/class/formulario';
import { objUsuario } from 'src/class/usuario';
import { StatusAgendamento } from 'src/enum/statusAgendamento.enum';
import { SearchFormularioPipe } from 'src/pipes/search-formulario.pipe';
import { AuthService } from 'src/services/auth.service';
import { ContaService } from 'src/services/component/conta.service';
import { NotificacaoSistemaService } from 'src/services/component/notificacao-sistema.service';
import { FormularioService } from 'src/services/component/formulario.service';
import { DataService } from 'src/services/data.service';
import { LinksService } from 'src/services/links.service';
import { LocalhostService } from 'src/services/localhost.service';
import { ModalConfirmacaoService } from 'src/services/modal-confirmacao.service';
import { SiglaService } from 'src/services/siglaService.service';
import { ThemeService } from 'src/services/theme.service';
import { ToastService } from 'src/services/toast.service';
import { ValidatorService } from 'src/services/validator.service';

declare var bootstrap: any;

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css']
})
export class FormComponent {
  private destroy$: Subject<void> = new Subject<void>()

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('formViewer', { static: false }) formViewer!: ElementRef;

  usr_id: string = "";
  usr_tipo: string = "";
  usr_token: string = "";

  usr_obj = new objUsuario;

  agenda_arr: any [] = [];

  pesquisa="";
  pag = 1;
  contador = 5;
  pageSize = 5;
  pageIndex = 0;
  totalizador = 0;
  maxSize = 5;
  visualizando = this.contador;
  lightMode: any;
  modoView = false;
  modoViewNum = 12;

  private subscription: Subscription;

  linksAgenda: Links[] = [];

  statusAgendamento = StatusAgendamento;

  formularios: Formulario[] = [];
  displayedFormularios: Formulario[] = [];
  loading: boolean = true;
  sortedData: Formulario[] = [];

  loader = this.loadingBar.useRef('http');
  empresaSigla: any | undefined;

  objFormViewer: Formulario | any = new Formulario() ;
  modalsMap = new Map<ElementRef, any>();

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private themeService: ThemeService,
    private linksService: LinksService,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastService,
    private paginatorIntl: MatPaginatorIntl,
    private searchFormularioPipe: SearchFormularioPipe,
    private loadingBar: LoadingBarService,
    private modalConfirmacaoService: ModalConfirmacaoService,
    private formularioService: FormularioService,
    private localhostService: LocalhostService,
    private siglaService: SiglaService,
    private conta: ContaService,
    private userService: AuthService,
    private notificacaoService: NotificacaoSistemaService,
    private validatorService: ValidatorService,
  ){
    this.subscription = this.themeService.lightMode$.subscribe(lightMode => {
      this.lightMode = lightMode;
    });

    this.paginatorIntl.itemsPerPageLabel = 'Itens por página:';
    this.paginatorIntl.nextPageLabel = 'Próxima página';
    this.paginatorIntl.previousPageLabel = 'Página anterior';
    this.paginatorIntl.firstPageLabel = 'Primeira página';
    this.paginatorIntl.lastPageLabel = 'Última página';

    // Personalize a indexação para começar em 1
    this.paginatorIntl.getRangeLabel = this.getPortugueseRangeLabel;

    // Alimenta o serviço com a empresaSigla
    // this.router.events.subscribe((event) => {
      // if (event instanceof NavigationEnd) {
        this.route.params
        .pipe(takeUntil(this.destroy$))
        .subscribe(params => {
          this.empresaSigla = params['empresaSigla'];
          this.siglaService.setEmpresaSigla(this.empresaSigla?.toString());
          this.formularioService.getFormulario(this.empresaSigla);
        });
      // }
    // });
  }


  ngOnInit() {

    this.getCache();

    // console.log(this.statusAgendamento)

    this.linksAgenda = this.linksService.getLinksAgenda();

    this.changeDetectorRef.detectChanges();

  }

  routerLink(rota: string, id: any = null){
    if(id != null){
      this.router.navigate([`${this.empresaSigla}/${rota}`, id]);
    }else{
      this.router.navigate([`${this.empresaSigla}/${rota}`]);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getCache(){

    let modoView = localStorage.getItem("modoView");

    let modoViewNum = localStorage.getItem("modoViewNum");

    if(modoView){
      this.modoView = modoView == 'true' ? true : false
    }

    if(modoViewNum){
      this.modoViewNum = parseInt(modoViewNum);
    }

    try{
      const usr = JSON.parse(localStorage.getItem('user')!);
      // this.usr_id = usr.Id;
      // this.usr_tipo = usr.Formulario;
      // this.usr_token = usr.Token;
      this.usr_id = "1";
      this.usr_tipo = "M";
      this.usr_token = "usr.Token";
      if(this.usr_tipo != "M" && this.usr_tipo != "A"){
        this.router.navigate(['/home']);
      }
    }catch{
      this.router.navigate(['/home']);
    }

    this.changeDetectorRef.detectChanges();

    this.formularioService.getAllFormulario()
    .pipe(takeUntil(this.destroy$))
    .subscribe(
      (formularios: Formulario[]) => {
        // console.log(formularios)
        // Faça algo com as notificações atualizadas
        this.formularios = formularios;

        this.loading = false;

        this.displayedFormularios = this.formularios.slice(
          this.pageIndex * this.pageSize,
          (this.pageIndex + 1) * this.pageSize
        );

        this.route.queryParams.subscribe((params: any) => {
          // O parâmetro de consulta 'search' estará em params.search
          this.pesquisa = params.search ? params.search : '';
          // console.log(params)
          // Agora você pode usar o valor da pesquisa em sua função searchAgenda
          if(this.pesquisa != ''){
            this.searchFormulario();
          }
        });

      },
      error => {
        // console.error('Erro ao listar os Formulários:', error);
        this.router.navigate(['/home']);
      }
    );

  }

  searchFormulario(){
    const retorno = this.searchFormularioPipe.transform(this.formularios, this.pesquisa);

    if (this.paginator) {
      this.paginator.firstPage();
    }

    this.displayedFormularios = retorno;

    if(this.pesquisa == ""){
      this.displayedFormularios = this.formularios.slice(
        this.pageIndex * this.pageSize,
        (this.pageIndex + 1) * this.pageSize
      );
      this.paginator.length = this.formularios.length;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { search: null },
        queryParamsHandling: 'merge',
      });

    }else{

      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { ['search']: this.pesquisa },
        queryParamsHandling: 'merge',
      });

      this.displayedFormularios = retorno.slice(
        this.pageIndex * this.pageSize,
        (this.pageIndex + 1) * this.pageSize
      );
      if (this.paginator) {
        this.paginator.length = retorno.length;
      }
    }
  }

  handlePage(event: any) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;

    // Calcule o índice de início e fim dos itens a serem exibidos na página atual
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;

    // Atualize os itens a serem exibidos na tabela
    this.displayedFormularios = this.formularios.slice(startIndex, endIndex);

    // console.log(this.displayedFormularios)
  }

  sortData(sort: Sort) {
    const data = this.formularios.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      this.formularios = this.sortedData
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';

      switch (sort.active) {
        case 'id':
          return this.compare(a.id!, b.id!, isAsc);
        case 'status':
          return this.compare(a.status.valor, b.status.valor, isAsc);
        case 'nome':
          return this.compare(a.titulo.valor, b.titulo.valor, isAsc);
        case 'descricao':
          return this.compare(a.descricao.valor, b.descricao.valor, isAsc);
        case 'criado':
          return this.compare(a.criado.toString(), b.criado.toString(), isAsc);
        case 'atualizado':
          return this.compare(a.atualizado.toString(), b.atualizado.toString(), isAsc);
        default:
          return 0;
      }
    });

    // console.log(this.sortedData)
    this.formularios = this.sortedData

    this.displayedFormularios = this.formularios.slice(
      this.pageIndex * this.pageSize,
      (this.pageIndex + 1) * this.pageSize
    );
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // Personalize a função getRangeLabel para começar em 1
  getPortugueseRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return `0 de ${length}`;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return `${startIndex + 1} - ${endIndex} de ${length}`;
  }

  reload(){
    try {
      this.formularios = [];
      this.loading = true;

      this.loader.start()

      setTimeout(async () => {
        let formulario = await this.formularioService.getFormulario(this.empresaSigla);
        // console.log(formulario)

        if(formulario != undefined){
          this.formularios = formulario;
        }else{
          setTimeout(() => {
            this.loading = false;
            this.loader.complete()

          }, 500);
        }

        this.showInfo("Formulários atualizados com sucesso!!")
        this.loading = false;
        this.loader.complete()
      }, 1000);

    } catch (error) {
      this.showError("Ocorreu um erro na atualização da agenda")
      this.loader.complete()
    }

  }

  resetSearch(){
    this.pesquisa = "";
    this.displayedFormularios = this.formularios.slice(
      this.pageIndex * this.pageSize,
      (this.pageIndex + 1) * this.pageSize
    );
    this.paginator.length = this.formularios.length;

    // Use o serviço Router para navegar para a mesma rota sem o parâmetro de consulta
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { search: null },
      queryParamsHandling: 'merge',
    });
  }

  pags(pags: any) {
    const target = pags as HTMLTextAreaElement;
    this.contador = parseInt(target.value)
    const total = this.contador * this.pag
    this.visualizando = total;
    if(this.visualizando > this.totalizador && (this.visualizando > 0 && this.totalizador > 0)){
      this.visualizando = this.totalizador;
    }
  }

  modoTabela(){
    this.modoView = true;
    localStorage.setItem("modoView", "true");
  }


  modoCard(){
    this.modoView = false;
    this.modoViewNum = 12;
    localStorage.setItem("modoViewNum", "12");
    localStorage.setItem("modoView", "false");
  }

  deletarFormulario(id: any){
    const index = this.formularios.findIndex(agenda => agenda.id === id);

    if (index !== -1) {

      let titulo = 'Tem certeza que deseja excluir o formulário?';
      let mensagem = ``;

      this.modalConfirmacaoService.openModal(titulo, mensagem).then(async (confirmation: boolean) => {
        if (confirmation) {
          // console.log('SIM!');
          // Encontrou um item com o ID correspondente, exclua-o

          const docId = this.formularios[index].id != null ? this.formularios[index].id?.toString() : "";

          const formulario = this.formularios[index]

          await this.conta.p_getSiglaConta('contas', this.empresaSigla)
          .then((conta) => {
            // Faça algo com os dados obtidos
            // console.log('Dados da conta: deletarFormulario', conta);
            this.localhostService.deleteDados(`${conta.id}_formularios`, { id: docId })
            .then(async (response: any) => {
              // console.log('Atualização bem-sucedida:', response);
              this.showSuccess(`Formulario deletado com sucesso`);

              // Nova notificação
              // 1 - empresaSigla: any,
              // 2 - titulo: string,
              // 3 - texto: string,
              // 4 - rotaSemParamNome: string,
              // 5 - rotaSemParamListar: string,
              // 6 - rotaComParamNome: string = "",
              // 7 - rotaComParamCaminho: string = "",
              // 8 - rotaComParamParam: string = "",
              // 9 - linkExternoNome: string = "",
              // 10 - linkExternoURL: string = "",
              // 11 - idReferencia: string,
              // 12 - tipo: string,
              // 13 - idResponsavel: string,
              // 14 - nomeResponsavel: string

              const usr = await this.userService.carregarUsuario(this.empresaSigla)

              this.notificacaoService.criarNotificacao(
                this.empresaSigla,
                `${formulario.titulo.valor}`,
                `O formulário foi deletado.`,
                'Listar Formulários',
                'formularios',
                '',
                ``,
                ``,
                '',
                '',
                ``,
                `Formulário`,
                `${usr.id}`,
                `${usr.displayName.valor}`
              )

              this.displayedFormularios = this.formularios.slice(
                this.pageIndex * this.pageSize,
                (this.pageIndex + 1) * this.pageSize
              );
            })
            .catch((error: any) => {
              // console.error('Erro ao deletar dados:', error);
              this.showError("Formulário não encontrada para exclusão \n" + error);
            });
          },
          (error: any) => {
            // console.error('Erro ao deletar dados:', error);
            // Trate o erro conforme necessário
          }).catch((error) => {
            // Trate o erro
            // console.log('Erro ao obter dados da conta:', error);
          });

        } else {
          // console.log('NÃO');
        }
      });

    } else {
      // Não encontrou um item com o ID correspondente
      this.showError("Formulário não encontrado para exclusão");
    }
  }

  atualizarStatusFormulario(id: any){

    const index = this.formularios.findIndex((item: Formulario) => item.id === id);

    if (index !== -1) {

      let titulo = 'Tem certeza que deseja alterar o status do formulário?';
      let mensagem = `<div class="text-cor-padrao box-gen-card-list ag-mt-0">
                        <p class="ag-mb-5">
                          <span>${this.formularios[index].titulo.valor}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-danger">Status atual: </span>
                          <span>${this.formularios[index].status.valor ? "Ativo" : "Desativado"}</span>
                        </p>
                        <p class="ag-mb-5">
                          <span class="text-cor-sucesso">Novo status: </span>
                          <span>${!this.formularios[index].status.valor ? "Ativo" : "Desativado"}</span>
                        </p>
                      </div>`;

      this.modalConfirmacaoService.openModal(titulo, mensagem).then(async (confirmation: boolean) => {
        if (confirmation) {
          // console.log('SIM!');
          // Atualize o item existente
          this.formularios[index].status.valor = !this.formularios[index].status.valor;

          const docId = this.formularios[index].id != null ? this.formularios[index].id?.toString() : "";
          const plainObject = JSON.stringify(this.formularios[index])
          const plainString = JSON.parse(plainObject)

          plainString.descricao.status = null;
          plainString.titulo.status = null;

          await this.conta.p_getSiglaConta('contas', this.empresaSigla)
          .then((conta) => {
            // Faça algo com os dados obtidos
            // console.log('Dados da conta: atualizarStatusServico', conta);
            this.localhostService.putDados(`${conta.id}_formularios`, docId!, plainString)
            .then(async (response: any) => {
              // console.log('Atualização bem-sucedida:', response);
              this.showSuccess(`Status do formulário ${this.formularios[index].titulo.valor} alterado para ${this.formularios[index].status.valor ? "ativado" : "desativado"}`);

              // Nova notificação
              // 1 - empresaSigla: any,
              // 2 - titulo: string,
              // 3 - texto: string,
              // 4 - rotaSemParamNome: string,
              // 5 - rotaSemParamListar: string,
              // 6 - rotaComParamNome: string = "",
              // 7 - rotaComParamCaminho: string = "",
              // 8 - rotaComParamParam: string = "",
              // 9 - linkExternoNome: string = "",
              // 10 - linkExternoURL: string = "",
              // 11 - idReferencia: string,
              // 12 - tipo: string,
              // 13 - idResponsavel: string,
              // 14 - nomeResponsavel: string

              const usr = await this.userService.carregarUsuario(this.empresaSigla)

              this.notificacaoService.criarNotificacao(
                this.empresaSigla,
                `${plainString.titulo.valor}`,
                `O status do formulário foi atualizado para ${plainString.status.valor ? "ativado" : "desativado"}.`,
                'Listar Formulários',
                'formularios',
                'Editar Formulário',
                `formularios/formulario`,
                plainString.id?.toString(),
                '',
                '',
                plainString.id!.toString(),
                `Formulário`,
                `${usr.id}`,
                `${usr.displayName.valor}`
              )
            })
            .catch((error: any) => {
              // console.error('Erro ao atualizar dados:', error);
              this.showError("Formulario não encontrado para atualização \n" + error);
            });

          },
          (error: any) => {
            // console.error('Erro ao atualizar dados:', error);
            // Trate o erro conforme necessário
          }).catch((error) => {
            // Trate o erro
            // console.log('Erro ao obter dados da conta:', error);
          });

          // DataService.setItem("Formulario", this.formularios);
          // localStorage.setItem("Formulario", JSON.stringify(this.formularios))
          // this.showSuccess(`Status do tipo ${this.formularios[index].status.valor ? "ativado" : "desativado"}`);
        } else {
          // console.log('NÃO');
        }
      });


    } else {
      // O item não foi encontrado no array, você pode tratar isso conforme necessário
      this.showError("Formulario não encontrada para atualização");
    }
  }

  openModalFormViewer(idForm: any) {
    let forms = this.formularios;

    const index = forms.findIndex((item: Formulario) => item.id === idForm);

    if (index !== -1) {
      // Clona o objeto original para criar uma cópia independente

      const clone = Object.assign(new Formulario(), this.clonarObjeto(forms[index]))

      // Ordena as chaves pelo campo "ordem"
      const chavesOrdenadas = Object.keys(clone.camposDinamicos).sort((keyA, keyB) => {
        const campoA = clone.camposDinamicos[keyA];
        const campoB = clone.camposDinamicos[keyB];
        if (campoA.ordem < campoB.ordem) {
          return -1;
        }
        if (campoA.ordem > campoB.ordem) {
          return 1;
        }
        return 0;
      });

      // Cria um novo objeto `camposDinamicosOrdenados` com as chaves ordenadas
      let camposDinamicosOrdenados: any = {};
      chavesOrdenadas.forEach(chave => {
        camposDinamicosOrdenados[chave] = clone.camposDinamicos[chave];
      });

      // Substitui o objeto original pelos campos ordenados
      clone.camposDinamicos = camposDinamicosOrdenados;

      this.objFormViewer = clone;
      // console.log(this.objFormViewer);
      this.abrirModal(this.formViewer.nativeElement);
    }
  }

  // Método para clonar profundamente um objeto
  private clonarObjeto(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }

  abrirModal(event: any) {
    // Ativar o modal usando a biblioteca do Bootstrap
    // const modal = new bootstrap.Modal(event);
    // modal.show();
    const modalElement = event;
    if (modalElement) {
        const modalInstance = new bootstrap.Modal(modalElement);
        this.modalsMap.set(event, modalInstance); // Armazenar a instância do modal no mapa
        modalInstance.show();
    } else {
        // console.error("Elemento do modal não encontrado");
    }
  }

  fecharModal(event: any){
    // console.log(event)
    // const modal = new bootstrap.Modal(event);
    // modal.hide();
    const modalInstance = this.modalsMap.get(event);
    if (modalInstance) {
        modalInstance.hide(); // Fechar o modal
    } else {
        // console.error("Instância do modal não encontrada");
    }
  }

  getKeysCamposDinamicos(obj: any): string[] {
    return Object.keys(obj);
  }

  validarForm() {
    if (this.objFormViewer && this.objFormViewer?.camposDinamicos) {
      Object.keys(this.objFormViewer?.camposDinamicos).forEach(chave => {
        const campo = this.objFormViewer?.camposDinamicos[chave];
        this.validarCampo(campo);
      });
    }
    // console.log(this.objFormViewer);
  }

  private validarCampo(campo: any){
    // console.log(campo)
    if(campo){
      campo.status = this.validatorService.criarValidacao(campo.valor, campo.validacoesCustomizadas);
    }
  }

  private showSuccess(msg: string){
    this.toast.showToast('<i class="bi bi-check-circle-fill " style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'success');
  }

  private showError(msg: string){
    this.toast.showToast('<i class="bi bi-x-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'danger');
  }

  private showInfo(msg: string) {
    this.toast.showToast('<i class="bi bi-info-circle-fill" style="font-size: 25px;padding-right: 10px;"></i> ' + msg, 'info');
  }

}
